import { signal, WritableSignal } from '@angular/core';
import { StateEnum } from '../enums';
import { StateType } from '../types';

export class State {
  private state: WritableSignal<StateType>;

  constructor(initialState: StateType = StateEnum.Initial) {
    this.state = signal<StateType>(initialState);
  }

  public onError(): void {
    this.state.set(StateEnum.Error);
  }

  public get isError(): boolean {
    return this.state() === StateEnum.Error;
  }

  public onSuccess(): void {
    this.state.set(StateEnum.Success);
  }

  public get isSuccess(): boolean {
    return this.state() === StateEnum.Success;
  }

  public onInitial(): void {
    this.state.set(StateEnum.Initial);
  }

  public get isInitial(): boolean {
    return this.state() === StateEnum.Initial;
  }

  public onPending(): void {
    this.state.set(StateEnum.Pending);
  }

  public get isPending(): boolean {
    return this.state() === StateEnum.Pending;
  }
}
